import {useShopperContext, useUsid} from '@salesforce/commerce-sdk-react'
import {isServer} from '@salesforce/retail-react-app/app/utils/utils'
import useShipToCountry from '@app/hooks/use-ship-to-country'
import {getLocalStorageJSONItem} from '@app/utils/utils'
/**
 * Custom React hook that retrieves and manages page parameters from the current route or URL.
 * Typically used to extract query parameters, path variables, or other relevant data needed for page rendering.
 * @returns {Object} An object containing the current page parameters.
 */
export const usePageParameters = (pageId, options = {}) => {
    const {usid} = useUsid()
    const {shipToCountry} = useShipToCountry()
    // If the country code is still being set in local storage, don't include it in the parameters
    // meaning the shopper context is not yet set and the customer groups are not yet applicable
    const countryCodeStillSetting = getLocalStorageJSONItem('countryCode')

    const {data: shopperContext} = useShopperContext(
        {
            parameters: {usid}
        },
        {enabled: Boolean(!isServer && usid)}
    )

    const parameters = {pageId}

    if (options.includeCountry && !countryCodeStillSetting) {
        const shipToCountryId = shipToCountry?.id
        const shopperContextCountry = shopperContext?.geoLocation?.countryCode

        if (shipToCountryId === shopperContextCountry) {
            parameters.c_country = shipToCountryId
        }
    }

    return parameters
}
